
    <fieldmagic-icon
      purpose="clicking"
      tooltip="Mark/Unmark as home page"
      [icon]="[{
        icon: 'star',
        klass: (marked) ? 'text-warning' : 'text-reset',
        variant: (marked) ? 'solid' : 'regular'
      }]"
      position="center"
      (click)="onToggle()"
    >
    </fieldmagic-icon>
  